
import { useEffect } from 'react';

const SITE_NAME = '铁头功的博客';

interface SeoOptions {
  title: string;
  description?: string;
}

function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

/** 为每个路由设置标题、描述与 Open Graph 信息 */
export function useSeo({ title, description }: SeoOptions): void {
  useEffect(() => {
    const fullTitle = title === SITE_NAME ? SITE_NAME : `${title} · ${SITE_NAME}`;
    document.title = fullTitle;
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:title', fullTitle);
      setMeta('property', 'og:description', description);
      setMeta('property', 'og:type', 'website');
    }
  }, [title, description]);
}
